import { API_URL } from '..';
import { fetch } from '../fetchWrapper/fetch';

export const assignOptionGroupToItem = async (itemId: string, optionGroupIds: string[]): Promise<void> => {
  const url = `${API_URL}/items/${itemId}/option-groups`;

  try {
    const response = await fetch(url, {
      method: 'PUT',
      body: JSON.stringify({
        option_groups: optionGroupIds.map((option_group_id, index) => ({
          option_group_id,
          display_order: index + 1,
        })),
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const text = await response.text().catch(() => '');
      throw new Error(text || `Request failed with status ${response.status}`);
    }
  } catch (error) {
    if (error instanceof Error) throw error;
    throw new Error('Something went wrong whilst assigning the option group');
  }
};
